const formatDate = (dateTime) => {
  const month = ['Januari', 'Febuari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
  let dateFormatValue = new Intl.DateTimeFormat().format(new Date(dateTime))
  dateFormatValue = dateFormatValue.split('/')
  return (`${dateFormatValue[1]} ${month[dateFormatValue[0] - 1]} ${dateFormatValue[2]}`)
}

export default formatDate
